var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "setPassword", attrs: { id: "set-password-app" } },
    [
      _c("div", { staticClass: "passwordContainer" }, [
        _c("img", {
          staticClass: "logo",
          attrs: {
            src: _vm.darkMode
              ? _vm.brandingService.getLoginDarkLogoUrl()
              : _vm.brandingService.getLoginLogoUrl(),
            alt: "brandingService.getLoginLogoAlt()",
          },
        }),
        _vm._v(" "),
        !_vm.submitted
          ? _c(
              "section",
              { staticClass: "middle form" },
              [
                _c("h1", { staticClass: "password-title" }, [
                  _vm._v("Set Password"),
                ]),
                _vm._v(" "),
                _c("PasswordEntry", {
                  on: { "password-updated": _vm.updatePassword },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary submit",
                    attrs: { disabled: _vm.validateFields() },
                    on: { click: _vm.submitPassword },
                  },
                  [_vm._v("Submit")]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.submitted
          ? _c("section", { staticClass: "middle submitted" }, [
              _vm.submitError
                ? _c("div", [
                    _c("h1", { staticClass: "password-title" }, [
                      _vm._v("Something Went Wrong"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("There was an error processing your request."),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Please contact "),
                      _c("a", { attrs: { href: _vm.getSupportContactUrl() } }, [
                        _vm._v("support"),
                      ]),
                      _vm._v(" for further assistance with this issue."),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.submitError
                ? _c("div", [
                    _c("h1", { staticClass: "password-title" }, [
                      _vm._v("All Set"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Click on the link below to log into WXP Collaboration."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a", { attrs: { href: "/" } }, [_vm._v("Log In")]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "copywrite" }, [
          _vm._v("© " + _vm._s(_vm.currentYear) + " HP Inc.\n        "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                target: "_blank",
              },
            },
            [_vm._v("Privacy Statement")]
          ),
          _vm._v(",\n        "),
          _c(
            "a",
            {
              attrs: {
                href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                target: "_blank",
              },
            },
            [_vm._v("EULA")]
          ),
          _vm._v(",\n        and "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                target: "_blank",
              },
            },
            [_vm._v("DPA")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }